<template>
  <div class="wrap">
    <div class="main">
      <p class="title">{{ $t("deTopic.derivative.t32") }}</p>
      <p class="text">{{ $t("deTopic.derivative.t33") }}</p>
      <Checkbox shape="square" v-if="isChangeInfo" v-model="topIsCheck">{{
        $t("deTopic.derivative.t34")
      }}</Checkbox>
      <Checkbox shape="square" v-if="!isChangeInfo" v-model="topIsCheck">{{
        $t("deTopic.derivative.t35")
      }}</Checkbox>
      <p class="text">
        {{ $t("deTopic.derivative.t36") }}
      </p>
      <p class="text">
        {{ $t("deTopic.derivative.t37") }}
      </p>
      <p class="text">
        {{ $t("deTopic.derivative.t38") }}
      </p>
      <p class="text">
        {{ $t("deTopic.derivative.t39") }}
      </p>
      <p class="sub-title">{{ $t("deTopic.derivative.t40") }}</p>
      <p class="text">
        {{ $t("deTopic.derivative.t41") }}
      </p>
      <p class="text">
        {{ $t("deTopic.derivative.t42") }}
      </p>
      <p class="text">
        {{ $t("deTopic.derivative.t43") }}
      </p>
      <p class="text">
        {{ $t("deTopic.derivative.t44") }}
      </p>
      <p class="text">
        {{ $t("deTopic.derivative.t45") }}
      </p>
      <p class="text">
        {{ $t("deTopic.derivative.t46") }}
      </p>
      <Checkbox shape="square" v-model="passwordIsCheck">
          {{ isChangeInfo ? $t("deTopic.derivative.t48") : $t("deTopic.derivative.t47") }}
      </Checkbox>
    </div>
    <div
      class="btn-submit"
      :class="{ dis: !topIsCheck || !passwordIsCheck }"
      @click="next"
    >
      {{ $t("common.next_step") }}
    </div>
    <div class="sub-btn">
      <span @click="$router.go(-1)">{{ $t("common.back_pre_step") }}</span>
    </div>

    <!--  校验密码  -->
    <van-dialog
      v-model="checkPasswordShow"
      @cancel="checkPasswordShow = false"
      @closed="checkPassword = ''"
      @open="checkPassword = ''"
      @confirm="confirm"
      :cancelButtonText="$t('fail_reason.cancel')"
      :confirm-button-text="$t('fail_reason.confirm')"
      :title="$t('fail_reason.checkPassword')"
      :showCancelButton="true"
      :className="bgColorDialog"
    >
      <customField
        ref="custom-field-password"
        class="custom-field-box"
        type="password"
        :open-eye-function="true"
        v-model="checkPassword"
      ></customField>
    </van-dialog>
    <password-error-prompt
      v-show="pwdErrPromptOption.show"
      :err-code="pwdErrPromptOption.errCode"
      :err-html="pwdErrPromptOption.errHtml"
      @password-error-prompt-confirm="passwordErrorPromptConfirm"
      ref="password-error-prompt-el"
    ></password-error-prompt>
  </div>
</template>

<script>
import customField from "@/components/customField/index.vue";
import { Checkbox, Dialog, Toast } from "vant";
import passwordErrorPrompt from "@/components/passwordErrorPrompt.vue";
export default {
  components: {
    passwordErrorPrompt,
    Checkbox,
    [Dialog.Component.name]: Dialog.Component,
    customField
  },
  data() {
    return {
      isChangeInfo: false, // 是否修改了资料
      topIsCheck: false, // 顶部的 是否 同意
      passwordIsCheck: false, // 底部的 是否 同意
      checkPasswordShow: false, // 输入 密码 弹窗
      checkPassword: "", // 输入的密码
      pwdErrPromptOption: {
        show: false,
        errCode: -1,
        errHtml: ""
      }
    };
  },
  computed:{
    bgColorDialog(){
      return this.$store.getters["common/bgColor"] == 'black-theme' ? 'black-theme-dialog' : ''
    }
  },
  created() {
    const { isChangeInfo } = this.$route.query;
    this.isChangeInfo = isChangeInfo && isChangeInfo == 1;
  },
  methods: {
    next() {
      if (this.topIsCheck && this.passwordIsCheck) {
        // 全勾选可提交，输入登录密码提交
        this.checkPasswordShow = true;
      }
    },
    confirm() {
      if (this.checkPassword === "") {
        Toast({
          message: this.$t("fail_reason.checkPasswordTips")
        });
      } else {
        this.$apis
          .checkPasswordFail({
            password: this.checkPassword
          })
          .then(res => {
            
            // TODO: 开户-登录错误 Code 100173
            // TODO: 开户-登录错误，冻结 Code 100174
            this.checkPasswordShow = false;
            if (res.code) {
              if (res.code === 100174 || res.code === 100173) {
                this.pwdErrPromptOption.errCode = res.code;
                this.pwdErrPromptOption.errHtml = res.data.err_msg.h5;
                this.pwdErrPromptOption.show = true;
                this.$refs["password-error-prompt-el"].show = true;
              }
              return;
            }
            // 此处提交一下开户的类型 期货/证券
            const { openType } = this.$route.query;
            if (openType) {
              // 提交一下 选择 是否同意了上面的内容
              this.$apis
                .customerCommitment({
                  customer_commitment: {
                    id: this.isChangeInfo ? 1 : 2,
                    value: 1
                  }
                })
                .then(() => {
                  // 证券6 期货 3
                  // 开通类型 转为 需要开通的 服务id
                  const openTypeToSerId = {
                    1: 6,
                    2: 3,
                    3: 3
                  };
                  const server_id = openTypeToSerId[openType];
                  this.$apis
                    .saveServerInfo({
                      server_id
                    })
                    .then(res => {
                      //   提交信息
                      this.$router.push("/account-result");
                    });
                });
            }
          });
      }
    },
    passwordErrorPromptConfirm(errCode) {
      this.pwdErrPromptOption.show = false;
      if (errCode === 100173) {
        this.checkPasswordShow = true;
        this.$refs["custom-field-password"].setInputFocus();
        setTimeout(() => {
          this.$refs["custom-field-password"].setInputFocus();
        }, 500);
      }
    }
  }
};
</script>

<style scoped lang="less">
.wrap {
  padding-bottom: 40px;
  .main {
    /deep/ .van-checkbox {
      align-items: flex-start;
      margin-bottom: 20px;
    }
    padding: 0 20px 40px;
    background: #fff;
    .title {
      font-size: 32px;
      line-height: 100px;
      font-weight: bold;
      border-bottom: 1px solid #f5f5f5;
      margin-bottom: 20px;
    }
    .text {
      margin-bottom: 20px;
      line-height: 40px;
    }
    .sub-title {
      font-size: 30px;
      font-weight: bold;
      margin-bottom: 20px;
    }
  }
  .btn-submit {
    margin: 40px 50px;
    height: 100px;
    text-align: center;
    line-height: 100px;
    background: #1c0955;
    color: #fff;
    font-size: 32px;
    border-radius: 6px;
    &.dis {
      background: #aa9fcb;
    }
  }
  .sub-btn {
    color: #001870;
    text-align: center;
  }
  .custom-field-box {
    margin: 0 30px;
    @backgroundColor: #fff;
    border: 1px solid #ccc;
    background-color: @backgroundColor;

    /deep/ .eye,
    /deep/ .custom-field__control {
      background-color: @backgroundColor;
      text-align: center;
    }
    /deep/ .custom-field__control::placeholder {
      color: #c8c9cc;
    }
  }
}
@black: #1B1C24;
.black-theme {
  .main{
    background: @black;
    color: #FFFFFF;
  }
  .btn-submit{
    background: #377CFB;
  }
  .sub-btn{
    color: #377CFB;
  }
}


</style>
